(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["forteller-testimonial-row"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function mobileMQ() {
    return window.matchMedia('(max-width: 749px)');
  }

  function initTestimonialCarousel(section) {
    var mq = mobileMQ();
    var supporting = Array.from(section.querySelectorAll('.forteller-quote-card--supporting'));
    if (supporting.length < 2) return;

    // Remember original parent + next-sibling so we can restore exactly
    var originalParent = supporting[0].parentElement;
    var originalAnchor = supporting[supporting.length - 1].nextElementSibling;
    var carousel = null;

    function wrap() {
      if (carousel) return;
      carousel = document.createElement('div');
      carousel.className = 'forteller-testimonials__q-carousel';
      originalParent.insertBefore(carousel, supporting[0]);
      supporting.forEach(function (c) { carousel.appendChild(c); });
    }

    function unwrap() {
      if (!carousel) return;
      // Move cards back to originalParent in original order, before originalAnchor
      supporting.forEach(function (c) {
        originalParent.insertBefore(c, originalAnchor);
      });
      carousel.remove();
      carousel = null;
    }

    function update() {
      if (mq.matches) wrap(); else unwrap();
    }

    update();

    // Modern browsers: addEventListener on MediaQueryList
    if (mq.addEventListener) {
      mq.addEventListener('change', update);
    } else if (mq.addListener) {
      // older Safari
      mq.addListener(update);
    }
  }

  function bootAll(root) {
    (root || document).querySelectorAll('.forteller-testimonials').forEach(function (section) {
      if (section.__fvtInited) return;
      section.__fvtInited = true;
      initTestimonialCarousel(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(document); });
  } else {
    bootAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    bootAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["forteller-video-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initCarousel(section) {
    var sectionId = section.dataset.sectionId;
    var grid = section.querySelector('.forteller-video-showcase__grid');
    if (!grid) return;
    if (!section.classList.contains('forteller-video-showcase--carousel')) return;

    var cards = Array.from(grid.querySelectorAll('.forteller-video-card'));
    if (cards.length <= 1) return;

    var btnPrev = section.querySelector('.forteller-carousel-btn--prev');
    var btnNext = section.querySelector('.forteller-carousel-btn--next');
    var counterCurrent = section.querySelector('.forteller-carousel-counter__current');
    var counterTotal = section.querySelector('.forteller-carousel-counter__total');
    var pips = Array.from(section.querySelectorAll('.forteller-carousel-pip'));

    var current = 0;
    var total = cards.length;

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function getTargetOffset() {
      var track = grid.querySelector('.forteller-video-showcase__track');
      var card = cards[current];
      if (!track || !card) return null;
      var gridRect = grid.getBoundingClientRect();
      var trackRect = track.getBoundingClientRect();
      var cardRect = card.getBoundingClientRect();
      var currentTranslate = trackRect.left - gridRect.left;
      var cardCenterInGrid = cardRect.left - gridRect.left + cardRect.width / 2;
      var naturalCardCenter = cardCenterInGrid - currentTranslate;
      return (gridRect.width / 2) - naturalCardCenter;
    }

    function updateTrackOffset(animate) {
      var track = grid.querySelector('.forteller-video-showcase__track');
      if (!track) return;
      var target = getTargetOffset();
      if (target === null) return;

      var prev = track.style.translate || '0px';
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (animate && !reduced && typeof track.animate === 'function') {
        track.animate(
          [{ translate: prev }, { translate: target + 'px' }],
          { duration: 420, easing: 'cubic-bezier(0.4, 0, 0.2, 1)', fill: 'forwards' }
        );
      }
      // Always commit final value to inline style so subsequent reads are correct.
      track.style.translate = target + 'px';
    }

    function goTo(index) {
      if (index < 0 || index >= total) return;

      /* remove active from old */
      cards[current].classList.remove('is-active');
      if (pips[current]) {
        pips[current].classList.remove('is-active');
        pips[current].setAttribute('aria-selected', 'false');
      }

      current = index;

      /* set active on new */
      cards[current].classList.add('is-active');
      if (pips[current]) {
        pips[current].classList.add('is-active');
        pips[current].setAttribute('aria-selected', 'true');
      }

      /* update counter */
      if (counterCurrent) counterCurrent.textContent = pad(current + 1);
      if (counterTotal) counterTotal.textContent = pad(total);

      /* update button states */
      if (btnPrev) btnPrev.disabled = current === 0;
      if (btnNext) btnNext.disabled = current === total - 1;

      /* Center active card via Web Animations API (CSS transitions on
         `translate` stalled intermittently in Chrome). */
      updateTrackOffset(true);
    }

    /* arrow buttons */
    if (btnPrev) {
      btnPrev.addEventListener('click', function () { goTo(current - 1); });
    }
    if (btnNext) {
      btnNext.addEventListener('click', function () { goTo(current + 1); });
    }

    /* pip dots */
    pips.forEach(function (pip) {
      pip.addEventListener('click', function () {
        var idx = parseInt(pip.dataset.index, 10);
        if (!isNaN(idx)) goTo(idx);
      });
    });

    /* sibling card click → promote */
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var idx = parseInt(card.dataset.index, 10);
        if (!isNaN(idx) && idx !== current) goTo(idx);
      });
    });

    /* keyboard: arrow keys when focus inside section */
    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        goTo(current - 1);
      } else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        goTo(current + 1);
      }
    });

    /* touch swipe: horizontal swipe navigates between videos */
    var touchStartX = 0;
    var touchStartY = 0;
    var isSwiping = false;

    grid.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isSwiping = false;
    }, { passive: true });

    grid.addEventListener('touchmove', function (e) {
      if (!isSwiping) {
        var dx = Math.abs(e.touches[0].clientX - touchStartX);
        var dy = Math.abs(e.touches[0].clientY - touchStartY);
        if (dx > dy && dx > 10) {
          isSwiping = true;
        }
      }
      if (isSwiping) {
        e.preventDefault();
      }
    }, { passive: false });

    grid.addEventListener('touchend', function (e) {
      if (!isSwiping) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 50) {
        if (dx < 0) goTo(current + 1);
        else goTo(current - 1);
      }
    }, { passive: true });

    /* initialise counter total correctly */
    if (counterTotal) counterTotal.textContent = pad(total);

    /* mark first active */
    goTo(0);

    /* recenter on resize (instant, no animation) */
    window.addEventListener('resize', function () { updateTrackOffset(false); });

    /* Shopify theme editor: navigate to selected block */
    document.addEventListener('shopify:block:select', function (e) {
      if (e.detail.sectionId !== sectionId) return;
      var block = e.target.closest('.forteller-video-card');
      if (!block) return;
      var idx = parseInt(block.dataset.index, 10);
      if (!isNaN(idx)) goTo(idx);
    });
  }

  /* Boot on page load */
  document.querySelectorAll('[data-section-id]').forEach(function (section) {
    if (section.classList.contains('forteller-video-showcase')) {
      initCarousel(section);
    }
  });

  /* Shopify theme editor: re-init on section load/reload */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.forteller-video-showcase');
    if (section) initCarousel(section);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
